module.exports = __webpack_public_path__ + "img/img3.70f1e662.png";